import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { screens } from "tailwindcss/defaultTheme";
import { swipeSlideOnFocus } from "../../utils/swiper_util";
window.createLatestNewsSlider = (element) => {
  const swiperContainerElement = element.closest(".swiper-container");
  const swiperInstance = new Swiper(element, {
    modules: [Navigation],
    navigation: {
      nextEl: swiperContainerElement.querySelector(".swiper-button-next"),
      prevEl: swiperContainerElement.querySelector(".swiper-button-prev")
    },
    slidesPerView: 1.1,
    breakpoints: {
      [parseInt(screens.sm)]: {
        slidesPerView: 2.1
      },
      [parseInt(screens.lg)]: {
        slidesPerView: 3.1
      }
    },
    spaceBetween: 16
  });
  swipeSlideOnFocus(element, swiperInstance);
  return swiperInstance;
};
